










































import 'vue-loading-overlay/dist/vue-loading.css'
import { Vue, Component, Watch } from 'vue-property-decorator'
import { Dialog, Button } from 'mand-mobile'
import getBlobDuration from 'get-blob-duration'
import MediaVideo from '../common/MediaVideo.vue'
import ProgressBar from '../common/ProgressBar.vue'
import DialogPrompt from '../common/DialogPrompt.vue'
import { getReport, sendReport } from '@/lib/reportDesktop'
import { desktopInvalidTokenCheckAndHandler } from '@/lib/desktopInvalidTokenCheckAndHandler'

// tslint:disable-next-line
const Loading = require('vue-loading-overlay')
import {v1 as uuidv1} from 'uuid'
const FPS = 1
const WIDTH = 1280

interface IUploadResult {
  code?: string,
  message?: string,
  uploadTime?: number,
  transactionId?: string,
  score?: number,
  errorMsg?: string,
  tryCount?: number,
  returnUrl?: string,
}
interface IDetectionResult {
  code: string,
  transactionId: string,
  message: string,
  data?: {
    score: number,
    tryCount: number,
    returnUrl?: string,
  },
}

@Component({ components: {
  Loading,
  MediaVideo,
  ProgressBar,
  DialogPrompt,
  [Button.name]: Button,
  },
})
export default class Record extends Vue {
  loading: boolean = false
  preparing: boolean = false
  showMaxDurationHint: boolean = false
  showProgressBar: boolean = false
  stopProgress: boolean = false

  // count down timer
  isStartCountDown: boolean = false
  countDownTimer: any = null
  curCount: number = 0
  count: number = 3

  // reset and submit button
  isSubmitFlag: boolean = false
  isRerecordFlag: boolean = false

  // video durction timer
  durationTimer: any = null
  duration: number = 0

  // event tracking
  finalFile: object = {}
  blobObj: any = null
  videoDuration: number = 0

  get mediaVideo() {
    return this.$refs.mediaVideo as MediaVideo
  }

  // init
  async initRecordHandler() {
    try {
      await this.mediaVideo.initVideo()
      await this.countDownPromise()
      // console.log('Record', 'start count down')

      await this.mediaVideo.initRTC()
      this.startRecordHandler()
      // console.log('Record', 'start record')

      await this.countDurationPromise()
      await this.mediaVideo.stopRTC()
      this.maxDurationDialog()
    } catch (error) {
      console.warn(error)
    }
  }

  async startRecordHandler() {
    this.isStartCountDown = false
    this.isRerecordFlag = true
    this.showProgressBar = true
    try {
      this.preparing = true
      await this.mediaVideo.startRecord()
    } catch (error) {
      console.warn(error)
    } finally {
      this.preparing = false
    }
  }

  // submit
  async submitHandler() {
    try {
      this.resetDuration()
      this.mediaVideo.pauseRecord()
      await this.mediaVideo.stopRTC()
      this.stopProgress = true
      // console.log('Record', 'submit video', this.mediaVideo.videoContent)
      await this.showDuration()
      await this.eventTrackingHandler()
      this.mediaVideo.destroyCamera()
    } catch (error) {
      console.error(error)
    }
  }

  // upload video
  async uploadHandler(file: File): Promise<IUploadResult> {
    try {
      this.loading = true
      const body = new FormData()
      body.append('video', file)
      body.append('token', `${this.$route.query.biz_token}`)
      const uploadStartTime = new Date().getTime()
      const { data } = await this.$http.post<IDetectionResult>(
        '/liveness/h5/v1/detection',
         body,
        { headers: {'Content-type': 'multipart/form-data'}},
      )
      // console.log('Record', 'data', data)
      return {
        code: data.code,
        message: data.message,
        transactionId: data.transactionId,
        score: data.data ? data.data.score : 0,
        uploadTime: new Date().getTime() - uploadStartTime,
        tryCount: data.data ? data.data.tryCount : 0,
        returnUrl: data.data ? data.data.returnUrl : '',
      }
    } catch (error) {
      console.error(error)
      return { errorMsg: error.message }
    } finally {
      this.loading = false
    }
  }

  // event tracking
  async eventTrackingHandler() {
    const blob = this.mediaVideo.recorder.getBlob()
    this.blobObj = blob
    const file = new window.File([blob], this.uuid, { type: blob.type })
    if (!file) {
      return
    }
    try {
      const uploadResult = await this.uploadHandler(file)
      // if is invalid token, direct to pcResult page
      if (desktopInvalidTokenCheckAndHandler(uploadResult.code as string)) {
        return
      }
      if (uploadResult.errorMsg) {
        this.sendReportUpload(false, uploadResult.errorMsg, uploadResult)
        return
      }

      if (uploadResult.code === 'SUCCESS') {
        this.sendReportUpload(true, uploadResult.message || '', uploadResult)
        this.$router.push({
          name: 'pcResult',
          query: {
            biz_token: this.$route.query.biz_token,
            result: uploadResult.code,
            message: uploadResult.message,
            score: `${uploadResult.score}`,
            returnUrl: uploadResult.returnUrl,
            fromName: this.$route.query.fromName,
          },
        })
      } else {
        this.sendReportUpload(false, uploadResult.message || '', uploadResult)
        this.$router.push({
          name: 'pcResult',
          query: {
            biz_token: this.$route.query.biz_token,
            result: uploadResult.code,
            message: uploadResult.message,
            returnUrl: uploadResult.returnUrl,
          },
        })
      }
    } catch (error) {
      console.warn(error)
    }
  }

  countDownPromise() {
    this.isStartCountDown = true
    this.resetCountDown()
    return new Promise((resolve, reject) => {
      this.countDownTimer = setInterval(() => {
        this.curCount --
        // console.log('Record', 'count', this.curCount)
        if (this.curCount <= 0) {
          resolve()
          this.resetCountDown()
        }
      }, 1000)
    })
  }

  // get video duration
  countDurationPromise() {
    this.resetDuration()
    return new Promise((resolve, reject) => {
      this.durationTimer = setInterval(() => {
        this.duration ++
        // console.log('Record', 'duration timer', this.duration)
        if (this.duration >= 2) {
          this.isSubmitFlag = true
        }
        if (this.duration >= 8) {
          this.resetDuration()
          resolve()
        }
      }, 1000)
    })
  }

   // rerecord
  async rerecordHandler() {
    this.showProgressBar = false
    this.isSubmitFlag = false
    this.isRerecordFlag = false
    this.resetDuration()
    await this.initRecordHandler()
  }

   // duration prompt dialog
  maxDurationDialog() {
    this.resetDuration()
    this.mediaVideo.pauseRecord()
    this.showMaxDurationHint = true
  }

  async confirmHandler() {
    this.showMaxDurationHint = false
    // console.log('Record', 'confirm video', this.mediaVideo.videoContent)
    await this.showDuration()
    await this.eventTrackingHandler()
    this.mediaVideo.destroyCamera()
  }

  cancelHandler() {
    this.showMaxDurationHint = false
    this.rerecordHandler()
  }

  async showDuration() {
    const duration = await getBlobDuration(this.mediaVideo.recorder.getBlob())
    this.videoDuration = duration
    // console.log('Record', 'video durations', duration + 's')
  }

  resetDuration() {
    this.duration = 0
    clearInterval(this.durationTimer)
    this.durationTimer = null
  }

  resetCountDown() {
    this.curCount = this.count
    clearInterval(this.countDownTimer)
    this.countDownTimer = null
  }

  getReportResolve(result: boolean, message: string) {
    const report = getReport()
    const reportDetail = report.info.detail
    reportDetail.state = 'RESOLVE'
    reportDetail.result = result
    reportDetail.message = message

    reportDetail.videoFileFullName = this.uuid
    reportDetail.videoDuration = this.videoDuration
    reportDetail.videoOrigFormat = this.blobObj.type
    reportDetail.isResolved = true
    reportDetail.videoResolvedFormat = 'webm'
    reportDetail.videoResolvedSize = this.blobObj.size / 1024
    // 待定
    // reportDetail.videoOrigWidth = this.mediaVideo.recorder.width
    // reportDetail.videoOrigHeight = this.mediaVideo.recorder.height
    // reportDetail.resolveTime = ''
    // reportDetail.resolveType = 'rtc'
    // reportDetail.videoResolvedWidth = ''
    // reportDetail.videoResolvedHeight = ''

    return report
  }

  sendReportUpload(result: boolean, message: string, uploadResult: IUploadResult) {
    const report = this.getReportResolve(result, message)
    const reportDetail = report.info.detail
    reportDetail.state = 'UPLOAD'
    reportDetail.uploadTime = uploadResult.uploadTime
    reportDetail.transactionId = uploadResult.transactionId
    reportDetail.score = uploadResult.score
    reportDetail.tryCount = uploadResult.tryCount
    reportDetail.returnUrl = uploadResult.returnUrl
    sendReport(report)
  }

  get uuid() {
    return uuidv1() + '.webm'
  }

  mounted() {
    this.initRecordHandler()
  }
}
